import styled from "styled-components";
import { palette } from "styled-theme";

export const UnStyledLink = styled.a`
  text-align: left;
  text-decoration: none;
  cursor: pointer;
`;

export const ExternalLink = styled(UnStyledLink)`
  color:${palette("link", 1)};
  text-decoration: underline;
  
  &:hover {
    color:${palette("link", 0)};
    text-decoration: none;
  }
`;